import intlTelInput from 'intl-tel-input';

/**
 * при поиске в выборе кода страны
 * в случае если нажатие на кнопку esc то - не используем
 * stopPropagation - что бы сработало стандартное событие bootstrap dropdown
 * и dropdown закрылся
 * */
window.country_code_onkeydownStopPropagation = function(event) {
    if(event.key !== "Escape") {
        event.stopPropagation();
    }
}

/**
 * в поле поиска при нажатии на крестик, очищается поле с поиском
 * а значит все страны - опять показываем, если они были скрыты
 * */
window.country_code_search_clear = function(th) {
    th = $(th);
    th.closest("ul").find("li.iti__country").show();
};

/**
 * при нажатии на keyup вызывается это событие для
 * сортировки и поска стран по коду или названию
 * */
window.country_code_search = function(th, e) {
    e.stopPropagation();

    var thOriginal = th;
    th = $(th);

    // показываем-скрываем иконку очиски поля в зависимости есть ли какието данные
    window.show_hide_clear_input(th);

    var search = $.trim(th.val());
    // если поиск пуст, показываем все страны по умолчанию
    if (!search) {
        window.country_code_search_clear(thOriginal);
        return false;
    }

    // определяем по чему искать, по цыфрам или по названию стран
    var digit = false;
    if ((search.charAt(0) === "+") || (parseInt(search.charAt(0)) + "" === search.charAt(0))) {
        digit = true;
        search = search.replace(/[^0-9.]/g, ""); // оставляем только цыфры
    }

    // если поиск пуст, показываем все страны по умолчанию
    if (!search) {
        window.country_code_search_clear(thOriginal);
        return false;
    }


    // перебираем все страны и совершаем посик
    var lis = th.closest("ul").find("li.iti__country");
    lis.each(function() {
        var li = $(this);

        // поиск по цыфрам
        if (digit) {
            if (li.attr("data-dial-code").indexOf(search) !== -1) {
                li.show();
            } else {
                li.hide();
            }
        } else {
            // поиск по названию страны
            var code = li.attr("data-country-code").toLowerCase();
            var name = li.find(".en-name").text().toLowerCase();
            var origName = li.find(".orig-name").text().toLowerCase();
            search = search.toLowerCase();
            // поиск по названию или коду (если пока введено 2 символа)
            if (search.length <= 2) {
                if ((origName.indexOf(search) !== -1) || (name.indexOf(search) !== -1) || (code.indexOf(search) !== -1)) {
                    li.show();
                } else {
                    li.hide();
                }
            } else { // поиск только по стране, если введено больше чем 2 символа
                if ((origName.indexOf(search) !== -1) || (name.indexOf(search) !== -1)) {
                    li.show();
                } else {
                    li.hide();
                }
            }
        }
    });
};

const input = document.querySelector("#phone-code");

if (input) {
var geoChoose = false;
var iti = intlTelInput(input, {
    initialCountry: "auto",
    customContainer: 'codes',
    utilsScript: "/js/template/utility/intl-tel-input/utils.js?1638200991544",
    autoHideDialCode: false,
    preferredCountries: ["ua", "ru"],
    geoIpLookup: function(callback) {
        // если значение уже есть то выбираем его
        var currentCountryCode = $("#country_code").val();
        if (currentCountryCode) {
            callback(currentCountryCode);
        } else {
            // автопределение страны
            $.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
                var countryCode = (resp && resp.country) ? resp.country : "ua";
                geoChoose = true;
                callback(countryCode);
            });
        }
    },
});

const phoneInput = document.querySelector("#input-label-phone");
if (phoneInput) {
    input.addEventListener("countrychange", function () {
        var placeholder = "";
        var placeholderTries = 0;
        var placeholderInterval = setInterval(function() {
            placeholderTries++;
            placeholder = $.trim($(iti.telInput).attr("placeholder"));
            if (placeholder || (placeholderTries >= 15)) {
                clearInterval(placeholderInterval);
                if (placeholder) {
                    $(input).val(iti.getSelectedCountryData().dialCode);
                    var mask = "+" + (iti.getSelectedCountryData().dialCode).replace("9", "\\9") +  " 9{0,20}";
                    var im = new Inputmask(mask);

                    var phoneInputVal = $.trim($(phoneInput).attr("data-value"));
                    $(phoneInput).val(phoneInputVal ? phoneInputVal : "");
                    im.mask(phoneInput);

                    if (!geoChoose) { // фокусируемся после выбора кода, только если это не автовыбор по айпи
                        phoneInput.focus();
                    } else {
                        geoChoose = false;
                    }

                    // устанавливаем буквенное значение кода страны
                    $("#country_code").val(iti.selectedCountryData.iso2);
                }
            }
        }, 100);
    });
}

input.addEventListener("open:countrydropdown", function() {
    $("body").addClass("modal-open");

    // форматирование списка
    var iti__country = $("ul.iti__country-list");
    iti__country.find(".iti__country-name").each(function() {
        var th = $(this);
        var li = th.closest("li");
        var code = li.attr("data-dial-code");

        var text = $.trim(th.text());
        var text = text.split("(");
        if (("0" in text) && (!("1" in text))) {
            th.html("<span class='en-name'>" + text[0].replace(code, "") + "</span><span class='code-val'>" + code + "</span>");
        } else if ("1" in text) {
            th.html("<span class='en-name'>" + text[0].replace(code, "") + "</span><span class='orig-name'>" + text[1].replace("(", "").replace(")", "") + "</span><span class='code-val'>" + code + "</span>");
        }
        li.addClass("clearfix");
    });
    iti__country.prepend('' +
        '<div class="form-group-wrap">\n' +
        '                <div class="form-group has-float-label" onclick="event.stopPropagation();">\n' +
        '                    <input onkeypress="event.stopPropagation();" onkeydown="window.country_code_onkeydownStopPropagation(event);" onkeyup="window.country_code_search(this, event);" autocomplete="country_code_search" name="country_code_search" id="input-label-country_code_search" value="" class="form-control" type="text" placeholder=" ">\n' +
        '                    <label for="input-label-country_code_search">\n' +
        '                        ' + $("#phone-code").attr('data-search-text') + '\n' +
        '                    </label>\n' +
        '                    <svg onclick="window.clearInput($(this)); window.country_code_search_clear(this);" class="clear-svg right-svg" viewBox="0 0 24 24">\n' +
        '                        <path fill="currentColor" d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"></path>\n' +
        '                    </svg>\n' +
        '                </div>\n' +
        '</div>');
    iti__country.find("#input-label-country_code_search").focus();
});
input.addEventListener("close:countrydropdown", function() {
    $("body").removeClass("modal-open");
});
}





